<ion-content class="ion-padding">
  <div class="container max-w-3xl">
    <h1 class="text-2xl font-extrabold mb-4 dark:text-slate-100">Note legali</h1>

    <p class="mb-4">Ultimo aggiornamento: {{ lastUpdated }}</p>

    <section class="mb-4">
      <p>
        Tutti i contenuti di questo blog, tranne casi particolari, sono sotto licenza <strong>Creative Commons Attribution-Noncommercial-Share Alike 2.5</strong>.
        Puoi ridistribuire l’opera e modificarla, ma devi sempre citare l’autore originale (edmond) e distribuirla con la stessa licenza. Ti è inoltre vietato utilizzare i contenuti sotto questa licenza per fini commerciali.
      </p>
    </section>

    <section class="mb-4">
      <h2 class="font-semibold dark:text-slate-100">Liberatoria</h2>
      <p>
        Il sito non può essere considerato come testata giornalistica in quanto viene “aggiornato” in modo non regolare. Non può essere quindi considerato un prodotto editoriale ai sensi della legge n. 62 del 7/03/2001.
      </p>
      <p class="mt-2">
        Leggendo i contenuti di questo blog si accettano immediatamente queste condizioni.
      </p>
    </section>

    <section class="mb-4">
      <h2 class="font-semibold dark:text-slate-100">Contatti</h2>
      <p>Per questioni legali o richieste relative ai contenuti, contatta: <a href="mailto:alessandro.bompadre@gmail.com">alessandro.bompadre@gmail.com</a></p>
    </section>
  </div>
</ion-content>
